import { render } from "./HeroComponent.vue?vue&type=template&id=1d41c3fc&scoped=true"
import script from "./HeroComponent.vue?vue&type=script&lang=js"
export * from "./HeroComponent.vue?vue&type=script&lang=js"

import "./HeroComponent.vue?vue&type=style&index=0&id=1d41c3fc&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d41c3fc"]])

export default __exports__